import React, { useEffect, useState } from "react";
import { db } from "../firebase/firebaseConfig";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Select, MenuItem, Paper } from "@mui/material";

const AdminPanel = ({ user, role }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (role !== "admin") return; // Nur Admins dürfen Nutzer sehen

    const fetchUsers = async () => {
      const usersCollection = collection(db, "users");
      const userDocs = await getDocs(usersCollection);
      setUsers(userDocs.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    fetchUsers();
  }, [role]);

  const handleRoleChange = async (userId, newRole) => {
    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, { role: newRole });

    setUsers(prevUsers =>
      prevUsers.map(user => (user.id === userId ? { ...user, role: newRole } : user))
    );
  };

  if (role !== "admin") {
    return <Typography variant="h6" color="error">Kein Zugriff!</Typography>;
  }

  return (
    <Container maxWidth="md">
      <Typography variant="h4" gutterBottom align="center">Admin-Bereich</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>E-Mail</TableCell>
              <TableCell>Rolle</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map(user => (
              <TableRow key={user.id}>
                <TableCell>{user.displayName || "Unbekannt"}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>
                  <Select
                    value={user.role}
                    onChange={(e) => handleRoleChange(user.id, e.target.value)}
                  >
                    <MenuItem value="user">User</MenuItem>
                    <MenuItem value="admin">Admin</MenuItem>
                    <MenuItem value="htc">HTC</MenuItem>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default AdminPanel;
